import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {AuthGuard} from '../auth/auth.guard';
import {AuthService} from '../auth/auth.service';
import {LinkToSimulatorService} from './link-to-simulator.service';

@Injectable()
export class AuthWithSimulatorCookieGuard {

    constructor(
        private authService: AuthService,
        private authGuard: AuthGuard,
        private linkToSimulatorService: LinkToSimulatorService
    ) {}

    public canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean | UrlTree | Observable<boolean | UrlTree> {
        const loginFromCookie = this.linkToSimulatorService.readAndRemoveSimulatorLoginCookie();

        const beforeAuth$ = loginFromCookie
            ? this.authService.authorizeWithCredentials(
                loginFromCookie,
                this.linkToSimulatorService.password
            ).pipe(
                catchError(() => of(null))
            )
            : of(null);

        return beforeAuth$.pipe(
            map(() => this.authGuard.canActivate()),
            map(authGuardResult =>
                authGuardResult === true && loginFromCookie
                    ? true
                    : authGuardResult
            )
        );
    }

}
